export const bankAccountInitModel =  {
    bsb: '',
    no: '',
    name: ''
};